export const disclaimer = '免责声明：本信息由同花顺金融研究中心提供，仅供参考，同花顺金融 研究中心力求但不保证数据的完全准确，如有错漏请以中国证监会指定上市公司信息披露媒体为准。用户查看或依据这些内容所进行的任何行为造成的风险和结果都自行负责，与同花顺无关。';
